<template>
  <!-- <div class="topbar flex" style="z-index: 15;">
    <div class="fl">
      <a @click="returnPage">
        <i class="fa-angle-left"></i>
      </a>
    </div>
    <div class="span-title">
      <p class="f14">{{title}}</p>
      <p class="f12">{{title2}}</p>
    </div>
    <a class="lk-home" @click="toHome">
      <i class="fa-home"></i>
    </a>
  </div>-->
  <header class="aui-navBar aui-navBar-fixed b-line">
    <a href="javascript:;" @click="returnPage" class="aui-navBar-item">
      <i class="icon icon-return"></i>
    </a>
    <div class="aui-center">
      <span class="aui-center-title">{{title}}</span>
    </div>
    <a href="javascript:;" class="aui-navBar-item" @click="toHome">
      <i class="icon icon-sys"></i>
    </a>
  </header>
</template>

<script>
export default {
  name: 'book-top',
  props: {
    title: String,
    title2: String
  },
  methods: {
    returnPage () {
      this.$router.isBack = true
      this.$router.go(-1)
    },
    toHome () {
      this.$router.isBack = false
      this.$router.push('/home')
    }
  }
}
</script>

<style scoped>
</style>
